import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const ReadyToBookStyle = styled('div')`
    padding: 54px 64px;
    background: var(--sand-300);
    border-radius: 6px;
    margin-bottom: 40px;
    margin-top: 20px;
    color: var(--sand-700);

    .title-ready {
        ${typography.subhead}
        margin-bottom: 14px;
    }

    .content-ready {
        ${typography.bodyMd}
        margin-bottom: 32px;
    }

    .btn-pay {
        background-color: var(--orange-300) !important;
        width: 100%;
        height: 48px;
        padding: 12px 20px;
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        color: var(--sand-100);
    }

    ${media.mobile} {
        padding: 24px 16px;

        .btn-pay {
            height: 40px;
            padding: 8px 16px;
            ${typography.buttonMd}
            border-radius: 6px;
        }
    }
`;
export default ReadyToBookStyle;
